import { isAfter, isBefore, isSameDay, parse } from 'date-fns';
import { PropertySeasonalRule } from 'models/seasonality/SeasonalCancellationPolicy';

export interface VisibleSeasonalRule {
  rule: PropertySeasonalRule;
  leftPx: number;
  widthPx: number;
}

export const getVisibleSeasonalRules = ({
  rules,
  visibleDates,
  cellWidth,
}: {
  rules: PropertySeasonalRule[] | undefined;
  visibleDates: Date[];
  cellWidth: number;
}): VisibleSeasonalRule[] => {
  if (!rules?.length || visibleDates.length < 3) {
    return [];
  }
  const referenceDate = new Date();
  const firstVisible = visibleDates[1];
  const lastVisible = visibleDates[visibleDates.length - 2];

  return rules.flatMap<VisibleSeasonalRule>((rule) => {
    const ruleStart = parse(rule.startDate, 'yyyy-MM-dd', referenceDate);
    const ruleEnd = parse(rule.endDate, 'yyyy-MM-dd', referenceDate);
    if (isAfter(ruleStart, lastVisible) || isBefore(ruleEnd, firstVisible)) {
      return [];
    }
    const clippedStart = isBefore(ruleStart, firstVisible)
      ? firstVisible
      : ruleStart;
    const clippedEnd = isAfter(ruleEnd, lastVisible) ? lastVisible : ruleEnd;
    const startIndex = visibleDates.findIndex((d) =>
      isSameDay(d, clippedStart),
    );
    const endIndex = visibleDates.findIndex((d) => isSameDay(d, clippedEnd));
    if (startIndex < 0 || endIndex < 0) {
      return [];
    }
    return [
      {
        rule,
        leftPx: startIndex * cellWidth,
        widthPx: (endIndex - startIndex + 1) * cellWidth,
      },
    ];
  });
};
